<script setup lang="ts">
import { helpApps } from '~/data/apps';

const apps = ref(helpApps);

const route = useRoute();
const activeApp = computed(() => {
	const segments = (route.path || '/').split('/').filter(Boolean);
	const currentId = segments[0] || '';
	return apps.value.find((a: any) => a.id === currentId) || apps.value[0];
});

interface VDropdownType {
	hide: () => void;
}
const switcherDropdown = ref<VDropdownType | null>(null);
const closeDropdown = () => {
	if (switcherDropdown.value) { switcherDropdown.value.hide(); }
};
</script>

<template>
	<div class="article-app-switcher">
		<VDropdown ref="switcherDropdown">
			<button type="button" class="article-app-switcher__trigger">
				<span class="article-app-switcher__trigger-content">
					<HmIcon :name="activeApp?.icon || 'brand-hahnemuehle-logo'" />
					<span>{{ activeApp?.name || 'Active app' }}</span>
				</span>
				<HmIcon name="caret-down" />
			</button>

			<template #popper>
				<NuxtLink
					class="article-app-switcher__link"
					:to="`/${app.id}`"
					v-for="app in apps"
					:key="app.id"
					@click="closeDropdown"
				>
					<HmIcon :name="app.icon" />
					<span>{{ app.name }}</span>
				</NuxtLink>
			</template>
		</VDropdown>
	</div>
</template>

<style lang="scss">
@layer components
{
	.article-app-switcher
	{
		margin-block-end:$spacing-md;

		.v-popper
		{
			width:100%;
		}

		&__trigger
		{
			@include flex(between, center, 16);
			width:100%;
			border:1px solid var(--bg-basic-300);
			border-radius:$radius-xl;
			background-color:var(--bg-basic-0);
			padding:$spacing-sm;
		}
		&__trigger-content
		{
			@include flex(null, center, 8);
			font-weight:500;

			.icon
			{
				@include svg(32);
			}
		}
		&__link
		{
			@include flex(null, center, 8);
			padding:$spacing-xs;
			transition:var(--transition-fast);

			@include button-interaction(var(--bg-basic-300));

			.icon
			{
				@include svg(32);
			}
		}
	}
}
</style>
